
// Industry types with their content in French
const industryData = {
  restauration: {
    positive: {
      name: "Sophie Martin",
      stars: 5,
      date: "il y a 2 jours",
      text: "Superbe découverte ! Le risotto aux champignons était délicieux et le serveur très attentionné. Nous reviendrons sans hésiter.",
      reply: "Merci beaucoup Sophie pour votre chaleureux commentaire ! Nous sommes ravis que notre risotto ait su vous séduire et que notre équipe ait contribué à rendre votre repas agréable. À très bientôt pour une nouvelle dégustation !"
    },
    negative: {
      name: "Julien Dupont",
      stars: 2,
      date: "il y a 2 jours",
      text: "Très déçu par mon expérience. Service lent, viande trop cuite alors que j'avais demandé saignant, dommage.",
      reply: "Bonjour Julien, nous sommes sincèrement désolés que votre repas n'ait pas été à la hauteur de vos attentes. Nous prenons note de vos remarques concernant la cuisson et le temps d'attente afin d'améliorer immédiatement ces points. N'hésitez pas à revenir vers nous directement pour échanger davantage. Merci pour votre retour constructif."
    }
  },
  divertissement: {
    positive: {
      name: "Camille Moreau",
      stars: 5,
      date: "il y a 3 jours",
      text: "Nous avons passé une excellente après-midi en famille ! Les activités sont variées et adaptées à tous les âges. Mention spéciale au personnel très accueillant et souriant.",
      reply: "Merci beaucoup Camille pour ce retour très positif ! Nous sommes enchantés que vous ayez passé un agréable moment en famille chez nous. Votre compliment sur notre équipe leur fera très plaisir. À bientôt pour d'autres moments de divertissement !"
    },
    negative: {
      name: "Lucas Bernard",
      stars: 2,
      date: "il y a 3 jours",
      text: "Assez déçu par la visite, certaines attractions étaient fermées sans prévenir à l'avance, et le personnel semblait peu concerné.",
      reply: "Bonjour Lucas, nous sommes désolés que votre expérience n'ait pas été à la hauteur de vos attentes. Nous prenons votre remarque très au sérieux et allons veiller à mieux informer nos visiteurs sur les éventuelles fermetures d'attractions. Nous espérons vous accueillir à nouveau prochainement dans de meilleures conditions."
    }
  },
  hotellerie: {
    positive: {
      name: "Laura Petit",
      stars: 5,
      date: "il y a 4 jours",
      text: "Excellent séjour dans cet hôtel charmant ! Literie très confortable, petit-déjeuner copieux et personnel souriant. Je recommande vivement.",
      reply: "Un grand merci Laura pour ce commentaire enthousiaste ! Nous sommes heureux que vous ayez apprécié le confort de nos chambres ainsi que notre petit-déjeuner. Toute l'équipe sera ravie de vous accueillir à nouveau lors de votre prochain séjour chez nous !"
    },
    negative: {
      name: "Antoine Lefèvre",
      stars: 2,
      date: "il y a 4 jours",
      text: "Chambre mal insonorisée, difficile de dormir avec le bruit du couloir. Dommage car l'hôtel est bien situé.",
      reply: "Bonjour Antoine, merci d'avoir pris le temps de partager votre avis. Nous regrettons sincèrement que votre nuit ait été perturbée par le bruit. Sachez que nous travaillons actuellement sur l'amélioration de l'insonorisation des chambres afin d'offrir une meilleure expérience à nos clients. Nous espérons avoir l'occasion de vous accueillir à nouveau dans de meilleures conditions."
    }
  },
  sante: {
    positive: {
      name: "Sarah Leroy",
      stars: 5,
      date: "il y a 1 jour",
      text: "Institut très agréable avec une équipe professionnelle et attentionnée. Le soin du visage était parfait, je suis ressortie détendue et ravie du résultat !",
      reply: "Merci infiniment Sarah pour cet avis chaleureux ! Nous sommes ravis que vous ayez apprécié votre soin visage ainsi que l'attention portée par notre équipe. C'est toujours un plaisir de vous accueillir, à très bientôt pour un prochain rendez-vous détente !"
    },
    negative: {
      name: "Manon Fournier",
      stars: 2,
      date: "il y a 1 jour",
      text: "Accueil froid et prestation expédiée en 20 minutes au lieu des 45 annoncées. Je suis repartie déçue, je ne recommande pas.",
      reply: "Bonjour Manon, nous sommes navrés d'apprendre que votre expérience n'a pas été satisfaisante. Ce que vous décrivez ne correspond pas aux standards de qualité que nous souhaitons offrir à nos clientes. Nous allons immédiatement faire le nécessaire auprès de notre équipe afin que cela ne se reproduise plus. N'hésitez pas à nous contacter directement pour échanger davantage sur cette situation."
    }
  },
  automobile: {
    positive: {
      name: "Thomas Girard",
      stars: 5,
      date: "il y a 5 jours",
      text: "Garage sérieux et efficace. Ma voiture a été réparée rapidement, le mécanicien m'a clairement expliqué l'intervention et les tarifs étaient transparents. Je recommande sans hésiter !",
      reply: "Merci beaucoup Thomas pour votre confiance et votre recommandation ! Nous sommes ravis d'avoir pu répondre rapidement à votre besoin et que vous ayez apprécié la transparence de nos services. N'hésitez pas à revenir vers nous pour toute autre demande concernant votre véhicule."
    },
    negative: {
      name: "Émilie Rousseau",
      stars: 2,
      date: "il y a 5 jours",
      text: "Déçue par la prestation. J'ai récupéré ma voiture avec le même problème qu'avant l'intervention et personne n'a pris le temps de m'expliquer clairement pourquoi.",
      reply: "Bonjour Émilie, nous regrettons sincèrement cette situation et comprenons votre mécontentement. Notre priorité est d'apporter une solution efficace à chaque client. Nous vous invitons à revenir directement vers nous afin que nous puissions examiner ensemble le problème rencontré et y remédier rapidement. Merci pour votre retour précieux."
    }
  }
};

export type IndustryType = keyof typeof industryData;
export type SentimentType = 'positive' | 'negative';

export default industryData;
